<div class="grid">

    <div class="col-12">

        <p-card class="wal-tile">

            <ng-template pTemplate="header">
                <div class="custom-card-header">
                    <div class="header-text">Notification Preference Changes</div>
                    @if(isSummaryShown) {
                        <div class="header-totals">
                            <span class="total-badge">Total Accounts Changed: {{ totalAccounts }}</span>
                            <span class="total-badge">Total Preferences Changed: {{ totalChanges }}</span>
                            <!-- <span class="total-badge">Unique Preferences: {{ totalUniquePrefs }}</span> -->
                        </div>
                    }
                </div>
            </ng-template>

            <!--  S U M M A R Y  -->

            @if(isSummaryShown) {
                <div class="ng-template w-full">

                    <div class="grid">

                        <div class="col-5">

                            <p-table #dtt [columns]="summaryColumns" [value]="summaryRows" selectionMode="single"
                                class="wal-table"
                                tableStyleClass="prime-table" [rowsPerPageOptions]="[10,15,25,50]" [showCurrentPageReport]="true"
                                sortMode="multiple" [paginator]="true" [rows]="15">
                                <ng-template pTemplate="caption">
                                    Preference Changes by Type
                                </ng-template>
                                <ng-template pTemplate="header" let-columns>
                                    <tr>
                                        @for (col of columns; track col.field) {
                                            <th [pSortableColumn]="col.field"
                                                [style.display]="col.display"
                                                [style.width]="col.width">
                                                {{ col.header }}
                                                <p-sortIcon [field]="col.field"></p-sortIcon>
                                            </th>
                                        }
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-rowData let-columns="columns">
                                    <tr [pSelectableRow]="rowData">
                                        @for (col of columns; track col.field) {
                                            <td [style.width]="col.width" [style.display]="col.display">
                                                {{ rowData[col.field] }}
                                            </td>
                                        }
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="summary">
                                    <div style="text-align:left">
                                        <p-button type="button" label="CSV Export"
                                            styleClass="p-button-info wal-info p-button-raised p-button-rounded margin-left" (click)="dtt.exportCSV()">
                                        </p-button>
                                        <p-button type="button" label="PDF Export"
                                            styleClass="p-button-warning p-button-raised p-button-rounded margin-left" (click)="exportToPdf()">
                                        </p-button>
                                    </div>
                                </ng-template>
                            </p-table>

                        </div>

                        <div class="col-1"></div>

                        <div class="col-6 chart-col">
                            @if(tabValue === 'Summary' && hasData) {
                                @defer (on viewport) {
                                    <p-chart [type]="selectedChartType"
                                        #chart
                                        [data]="chartData"
                                        [options]="chartOptions"
                                        class="wal-chart-container">
                                    </p-chart>
                                } @placeholder {
                                    <div>Loading chart...</div>
                                } @error {
                                    <p>Failed to load the chart.</p>
                                }
                            }
                        </div>

                    </div>

                </div>
            }

            <!--  D E T A I L S  -->

            @if(isDetailsShown) {
                <div class="ng-template w-full">

                    <div class="p-datatable p-component">

                        <div class="p-datatable-header">
                            <div class="header-row">
                                <div class="wal-page-title">Notification Preference Change Details</div>
                            </div>
                        </div>

                        <div class="p-datatable-wrapper">

                            <!-- Column headers with sorting -->
                            <div class="thead row-grid">
                                <div class="th clickable" (click)="toggleSort('prefChangeId')">
                                    Event ID <span>{{ sortField === 'prefChangeId' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span>
                                </div>
                                <div class="th clickable" (click)="toggleSort('createDate')">
                                    Event Date <span>{{ sortField === 'createDate' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span>
                                </div>
                                <div class="th clickable" (click)="toggleSort('extAccountId')">
                                    Account ID <span>{{ sortField === 'extAccountId' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span>
                                </div>
                                <div class="th clickable" (click)="toggleSort('prefName')">
                                    Preference Name <span>{{ sortField === 'prefName' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span>
                                </div>
                                <div class="th clickable" (click)="toggleSort('prevValue')">
                                    Previous Value <span>{{ sortField === 'prevValue' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span>
                                </div>
                                <div class="th clickable" (click)="toggleSort('curValue')">
                                    Current Value <span>{{ sortField === 'curValue' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span>
                                </div>
                            </div>

                            <!-- Scrollable viewport -->
                            <div class="tbody-viewport">
                                @if (datasource) {
                                    <div
                                        class="tr row-grid"
                                        *uiScroll="let row of datasource; let even = even"
                                        (click)="onRowClick(row)"
                                        [class.even]="even"
                                        [class.selected]="isSelected(row)"
                                    >
                                        <div class="td">{{ row.prefChangeId }}</div>
                                        <div class="td">{{ row.createDate }}</div>
                                        <div class="td">{{ row.extAccountId }}</div>
                                        <div class="td">{{ row.prefName }}</div>
                                        <div class="td">{{ row.prevValue }}</div>
                                        <div class="td">{{ row.curValue }}</div>
                                    </div>
                                }
                            </div>

                        </div>

                        <div class="p-datatable-footer p-text-secondary">
                        </div>

                    </div>

                </div>
            }

        </p-card>

    </div>

</div>

<p-confirmDialog class="lf-confirm-dialog" appendTo="body" key="client-dashboard-warning"></p-confirmDialog>
